import React from "react";

function severityClass(sev) {
    switch ((sev || "info").toLowerCase()) {
        case "danger":
            return "bg-red-600";
        case "warning":
            return "bg-yellow-600";
        default:
            return "bg-blue-600";
    }
}

export default function ToastNotice({ notice, onClose }) {
    if (!notice || notice.type !== "toast" || !notice.message) return null;

    return (
        <div className="fixed z-50 right-4 bottom-4 max-w-md w-[calc(100%-2rem)]">
            <div className={`text-white rounded-lg shadow-lg ${severityClass(notice.severity)} `}>
                <div className="p-4">
                    <div className="flex items-start gap-3">
                        <div className="flex-1 whitespace-pre-wrap text-sm">{notice.message}</div>
                        <button
                            type="button"
                            className="text-white/90 hover:text-white text-lg leading-none"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            &times;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
